export const TRACK_KEYS = {
  PAGE: 'page',
  CHAT_ID: 'chat_id',
  CHAT_ID_LIST: 'chat_id_list',
  CHAT_NUM: 'chat_num',
  BOT_ID: 'bot_id',
  CLICK_TYPE: 'clk_type',
  OPERATE_TYPE: 'operate_type',
};

export const WINDOW_CLICK_TYPE = {
  CONFIRM: '1',
  CANCEL: '2',
};
